export default "__VITE_ASSET__BWw4IWWQ__"